import { FilterOutlined } from "@ant-design/icons";
import { Button, Checkbox, Collapse, Input, Radio, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import filter from "../../../icons/sort.svg";
import { filterFarmers, getProducts, getStaticProvinces } from "../../../service/api";
import { useQuery } from "@tanstack/react-query";
import FarmerFilterContext from "../../../context/farmerFilterContext";



function FilterResponsive({setFilteredFarmer}) {
  // const [fullName, setFullName] = useState(null);
  // const [phoneNumber, setPhoneNumber] = useState(null);
  // const [provinceId, setProvinceId] = useState(null);
  // const [cityId, setCityId] = useState(null);
  // const [productId, setProductId] = useState(null);
  // const [sort, setSort] = useState(null);
  // const [marked, setMarked] = useState(null);
  const {
    fullName,
    fullNameAction,
    phoneNumber,
    phoneNumberAction,
    provinceId,
    provinceIdAction,
    cityId,
    productId,
    productIdAction,
    sort,
    sortAction,
    marked,
    markedAction,
    resetFarmerAction,
  } = useContext(FarmerFilterContext);
  const [provinces, setProvinces] = useState([]);
  const [products, setProducts] = useState([]);

  const staticProvincesQuery = useQuery(
    ["staticsProvinces"],
    getStaticProvinces
  );


  const productsQuery = useQuery(["products"], getProducts);

  const clearFilter = () => {
    resetFarmerAction()  
  }

  useEffect(() => {
    if (staticProvincesQuery?.data) {
      let provs = staticProvincesQuery?.data?.map((province) => {
        return { label: province.name, value: province.id };
      });
      setProvinces(provs);
    }
  }, [staticProvincesQuery?.data]);



  useEffect(() => {
    let prods = productsQuery?.data?.map((product) => {
      return { label: product.persianName, value: product.pid };
    });
    setProducts(prods);
  }, [productsQuery?.data]);

  const charechterSearchLimit = (e) => {
    if (e.target.value.length !== 0 && e.target.value.length % 3 === 0) {
      fullNameAction(e.target.value);
    }
    if (e.target.value.length === 0) {
      fullNameAction(null);
    }
  };

  const phoneNumberSearchLimit = (e) => {
    if (e.target.value.length === 11) {
      phoneNumberAction(e.target.value);
    } else {
      phoneNumberAction(null);
    }
  };

  const query = useQuery(["farmers", fullName, phoneNumber, provinceId, productId, marked, sort], () => filterFarmers(fullName, phoneNumber, provinceId, cityId, productId, marked, sort));
 
  useEffect(()=> {
    setFilteredFarmer(query.data)
  }, [setFilteredFarmer, query.data])
  const items = [
    {
      key: "1",
      label: (
        <div className="flex flex-row gap-2 items-center  ">
          <FilterOutlined className="text-xl" />
          <p className="text-[0.625rem] text-justify w-full font-bold ">
            کارشناس گرامی، شما میتوانید از طریق فیلترهای زیر کشاورز های خود را
            مدیریت نمایید.
          </p>
        </div>
      ),
      children: (
        <div className="flex flex-col gap-[0.75rem]  ">
          <section className="flex flex-row gap-3 ">
            <Input
              style={{
                fontSize: "0.6rem",
                fontWeight: "bold",
                backgroundColor: "white",
                boxShadow: " 1px 1px 4px 0px rgba(0, 0, 0, 0.25)",
              }}
              className="w-1/2 rounded-[10px] "
              placeholder="نام و نام خانوادگی"
              onChange={charechterSearchLimit}

            />
            <Input
              style={{
                fontSize: "0.6rem",
                fontWeight: "bold",
                backgroundColor: "white",
                boxShadow: " 1px 1px 4px 0px rgba(0, 0, 0, 0.25)",
              }}
              className="w-1/2 rounded-[10px]"
              placeholder="شماره تماس"
              onChange={phoneNumberSearchLimit}
            />
          </section>
          <section className="flex flex-row  gap-2 ">
            <Select
              size="small"
              className="w-1/2 "
              placeholder="--انتخاب استان--"
              options={provinces}
              onChange={(value) => provinceIdAction(value)}
              value={provinceId ? provinceId : null}

            />
            <Select
              size="small"
              className="w-1/2"
              placeholder="--محصولات--"
              options={products}
              onChange={(e)=>productIdAction(e)}
              value={productId ? productId : null}
            />
          </section>
          <section>
            <section className="flex flex-col items-center justify-between gap-2">
              <div className="flex flex-row items-center justify-start w-full">
                <img className="w-[0.75rem] h-[0.5625rem]" alt="sort" src={filter} />
                <p className="whitespace-normal text-[0.5625rem] font-bold">مرتب سازی بر اساس:</p>
              </div>
              <div  className="items-center flex flex-row w-full justify-center whitespace-nowrap">
              <Radio.Group value={sort ? sort : null} onChange={(e)=>sortAction(e.target.value)}  size="small">
               
                  <Radio  style={{fontSize:"0.5625rem" ,fontWeight:"bold",direction:'ltr'}}  value={1}>جدیدترین</Radio>
                  <Radio  style={{fontSize:"0.5625rem",fontWeight:"bold" ,direction:'ltr'}}  value={2}>بیشترین برنامه‌غذایی</Radio>
                  <Radio  style={{fontSize:"0.5625rem",fontWeight:"bold",direction:'ltr'}}  value={3}>بیش‌ترین بازدید</Radio>
                
              </Radio.Group>
              </div>
              <Checkbox checked={marked ? marked : null} onChange={()=> markedAction(prev=> !prev)}    style={{fontSize:"0.5625rem",fontWeight:"bold"}}  className="font-body items-center">ستاره دار</Checkbox>

            </section>

          </section>
          <div className="items-center">

          <Button onClick={clearFilter} danger type="text" className="w-1/2 text-[0.5rem] font-bold">لغو تمامی فیلترها</Button>
          </div>
        </div>
      ),
    },
  ];
  return (
    <div className="bg-white ">
      <Collapse
        expandIconPosition="end"
        accordion={true}
        items={items}
      ></Collapse>
    </div>
  );
}

export default FilterResponsive;


